import React, {Component} from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import css from '../Customers/Customers.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import axios from 'axios';
import {fieldCustomersTimePeriods, DEFAULT_SELECTED_TIME_PERIOD } from "../../helpers/timePeriods";
import {connect} from "react-redux";
import moment from 'moment';
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import _, { forEach } from 'lodash';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';


const FieldCustomers = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    fieldTeamPost = {
        "limit": 25,
        "skip": 0,
        "fields": [
            "Id",
            "Name"
        ],
        "where": {
            "$or": [
                {
                    "Tech_1__c": this.props.user.apiId
                },
                {
                    "Tech_2__c": this.props.user.apiId
                },
                {
                    "Tech_3__c": this.props.user.apiId
                },
                {
                    "Tech_4__c": this.props.user.apiId
                },
                {
                    "Tech_5__c": this.props.user.apiId
                }
            ]
        }
    };

    // ---------- state: ----------
    state = {
        optionsTimePeriod: fieldCustomersTimePeriods,
        filterKeyword: '',
        workOrders: [],
        tableData: [],
        filterStagesOptions: [],
        selectedStages: [],
        showName: false,
        showDate__c: true
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        window.scrollTo(0, 0);
        this.fetchRecords();

        axios.get(
            '/sf/WorkOrder/describeField/Post_Install_Review_Result__c;',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                const pir = resPickFields.data.Post_Install_Review_Result__c;

                const filterStagesOptions = [
                    ...pir.picklistValues.map(item => ({
                        ...item,
                        checked: true
                    })),
                    {
                        active: true,
                        label: 'None',
                        value: null,
                        checked: true
                    }
                ];

                this.setState({
                    filterStagesOptions,

                    selectedStages: filterStagesOptions.map(item => item.value),
                });
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    fetchRecords = async () => {
        await axios.post(
            '/sf/FieldTeam/findNo',
            this.fieldTeamPost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records
                const ids = data.map(item => item.Id);

                if(ids.length !== 0){
                    this.getWorkOrders(ids);
                }
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error finding field teams:\n', err);
                }
            });
    };

    getWorkOrders = async (crewIds) =>{
        let woPost = {
            "limit": 1000,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Date__c",
                "Work_Types__c",
                "Regular_Hours__c",
                "OT_Hours__c",
                "HMOD__c",
                "Post_Install_Review_Result__c",
                "Opportunity__c",
                "Opportunity__r.Name",
                "Opportunity__r.CloseDate",
                "Opportunity__r.Internal_Stage__c",
                "Opportunity__r.StageName",
                "Opportunity__r.Type",
                "Opportunity__r.Pending_Sale_Date__c",
                "Opportunity__r.Post_Panel_Count__c"
            ],
            "where": {
                "Assigned_Field_Team__c": { "$in": crewIds },
                "Opportunity__r.Fake__c": false,
                "Opportunity__r.Final_Completion__c": null,
                "Opportunity__r.StageName": {$ne: 'Cancelled'}
            }
        };
        
        axios.post(
            '/sf/WorkOrder/findNo',
            woPost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const workOrders = res.data.records;
                const sortedData = _.orderBy(workOrders, ['Date__c'], ['desc']);

                this.setState({
                    workOrders: sortedData,
                    tableData: sortedData
                });

                this.timePeriodDropdownOnChange(DEFAULT_SELECTED_TIME_PERIOD.value);
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in Work Orders:\n', err);
                }
            });
    }

    handleFilterOnChange = (event) => {
        const filterKeyword = event.target.value.toLowerCase();

        this.setState({
            filterKeyword
        });
    };

    timePeriodDropdownOnChange = (val) => {
        // select time period object from list based on selected drop down value:
        const selectedTimePeriod = fieldCustomersTimePeriods.find(item => item.value === val);
        const { start, end } = selectedTimePeriod;
        const startDate = new Date(start);
        const endDate = new Date(end);
        const allData = this.state.workOrders;

        const filteredData = allData.filter(order => {
            const orderDate = new Date(order.Date__c);
            const normalizedOrderDate = new Date(orderDate.toISOString().split('T')[0]);
            const normalizedStart = new Date(startDate.toISOString().split('T')[0]);
            const normalizedEnd = new Date(endDate.toISOString().split('T')[0]);

            return normalizedOrderDate >= normalizedStart && normalizedOrderDate <= normalizedEnd;
        });

        this.setState({ tableData: filteredData });
    };

    filterByStagesOnChange = (optionList) => {
        const selectedStages = optionList
            .filter(item => item.checked)
            .map(item => item.value);

        this.setState({
            filterStagesOptions: optionList,
            selectedStages,
        });
    };

    displayedTable = () => {
        // filter table by filter keyword:
        return this.state.tableData
            .filter(item => {
                const itemName = item.Name.toLowerCase();
                return itemName.includes(this.state.filterKeyword);
            })
            // filter by selected stage (drop down):
            .filter(item => this.state.selectedStages.includes(item.Post_Install_Review_Result__c))
    };

    tableSort (value) {
        let sortedData = '';
        let show = 'show' + value;
        let showName = false;
        let showDate__c = false;

        switch (show) {
            case 'showName' :
                showName = true;
                break;
            case 'showDate__c' : 
                showDate__c = true;
                break;
            default:
                break;
        }

        if(value === 'Date__c') {
            sortedData = _.orderBy(this.state.tableData, [value], ['desc']);
        } else {
            sortedData = _.orderBy(this.state.tableData, [value], ['asc']);
        }
        this.setState({ 
            tableData: sortedData,
            showName: showName,
            showDate__c: showDate__c
        })
    };

    render() {
        return (
            <div className={css.Customers}>
                <SectionHeading heading="Customers" />

                {/* ---------- page controls row 1: ---------- */}
                <div className="row">
                    <div className="col-sm-12">
                        <h4>When</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <select id="timePeriod" onChange={(event) => this.timePeriodDropdownOnChange(event.target.value)} defaultValue={DEFAULT_SELECTED_TIME_PERIOD.value}>
                            {
                                // ----- select options - time period: -----
                                this.state.optionsTimePeriod.map((option, index) => <option key={index} value={option.value}>{option.label}</option>)
                            }
                        </select>
                    </div>
                </div>

                {/* ---------- page controls row 2: ---------- */}
                <div className="row pt-4">
                    <div className="col-12 col-lg-3">
                        {/* ----- filter table data: ----- */}
                        <div className="input-with-icons-container">
                            <FontAwesomeIcon icon={faFilter} />
                            <input className="input"
                                   type="text"
                                   placeholder="Filter Results"
                                   value={this.state.filterKeyword}
                                   onChange={(event) => this.handleFilterOnChange(event)}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-sm-8 col-lg-6 mt-4 mt-lg-0 mb-2 mb-md-0">
                        <div className="d-flex">
                            <CheckboxDropDown
                                button-outline
                                options={this.state.filterStagesOptions}
                                onDropdownSelect={(options) => this.filterByStagesOnChange(options)}
                                text="PIR Result"
                            />
                        </div>
                    </div>
                    {/* ----- show # of results: ----- */}
                    <div className="col-12 col-sm-4 col-lg-3 mt-4 mt-md-0 d-flex align-items-center justify-content-end">
                        Showing { this.displayedTable().length } of { this.state.tableData.length }
                    </div>
                </div>

                <div class="pt-4">
                    {/* ---------- Customers Table: ---------- */}
                    <table class="table table-sm table-borderless">
                        <thead>
                        <tr>
                            <th className={css.Customers__Pointer} onClick={() => this.tableSort('Name')}>Name {this.state.showName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                            <th>Modules</th>
                            <th>Hours</th>
                            <th>HMOD</th>
                            <th>PIR Result</th>
                            <th className={css.Customers__Pointer} onClick={() => this.tableSort('Date__c')}>WO Date {this.state.showDate__c ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            // ----- table rows: -----
                            this.displayedTable()
                                .map((customer) => {
                                    return (
                                        <tr key={ customer.Id }>
                                            <td>
                                                <Link to={`/fieldCustomers/${customer.Opportunity__c}`}>{ customer.Opportunity__r.Name }</Link>
                                            </td>
                                            <td>{ customer.Opportunity__r.Post_Panel_Count__c }</td>
                                            <td>{(customer.Regular_Hours__c + customer.OT_Hours__c).toFixed(2)}</td>
                                            <td>{ customer.HMOD__c ? (customer.HMOD__c).toFixed(2)  : customer.Regular_Hours__c && customer.Opportunity__r ? ((customer.Regular_Hours__c + (customer.OT_Hours__c * 2)) / customer.Opportunity__r.Post_Panel_Count__c).toFixed(2) : 0 }</td>
                                            <td>{ customer.Post_Install_Review_Result__c }</td>
                                            <td>{ moment(customer.Date__c).format('MMM D') }</td>
                                        </tr>
                                    );
                                })
                        }
                        </tbody>
                    </table>
                </div>
                
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(FieldCustomers);